import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoSm = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16.3261 4.85156L14.5801 8.97855L18.8658 12.0738L16.3261 4.85156Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.7705 11.0415L14.8181 14.2161C15.1356 14.5336 15.2943 14.851 15.2943 15.2479C15.2943 15.5653 15.2943 15.8828 15.1356 16.1209L21.961 20.8034L19.4213 13.6606L15.7705 11.0415Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.5009 16.8354C14.2628 16.9942 14.1041 17.0735 13.866 17.0735L14.1834 20.645L25.1358 28.5815L22.5168 22.391L14.5009 16.8354Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.8501 25.4862L19.5803 28.0259L21.9612 27.5497L15.6914 22.8672L15.8501 25.4862Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.882 16.5973C31.1677 10.883 26.7233 5.56555 19.8979 2.31158C19.8185 2.31158 19.7391 2.23221 19.5804 2.15285C18.5487 1.67666 15.4534 0.0893555 14.4217 0.0893555C14.3423 0.0893555 14.2629 0.0893555 14.1836 0.168721C14.0248 0.486181 9.10421 7.31158 7.9931 13.7401C7.19945 23.1846 11.7233 28.1846 15.6121 30.7243C19.8185 33.5021 24.2629 34.0576 24.3423 34.0576H24.4217L26.1677 39.6132L28.9455 40.0894L25.6915 30.0894L22.6756 28.0259L19.4217 28.7401L15.0566 25.8036V25.7243L14.8979 22.3116L13.3106 21.2005V21.1211L12.9137 16.9148C12.9137 16.9148 12.9137 16.9148 12.8344 16.8354C12.2788 16.5973 11.882 16.0417 11.882 15.4068C11.8026 14.4544 12.5169 13.6608 13.4693 13.5814C13.628 13.5814 13.7867 13.5814 14.0248 13.6608L15.0566 10.4862L13.628 9.37507V9.29571L16.3264 2.15285L17.2788 4.21634C17.3582 4.45444 27.4375 28.9782 28.3899 31.2798C29.8979 28.8989 30.9296 26.6767 31.4852 24.7719C32.1201 22.4703 32.2788 19.6925 31.882 16.5973Z",
			fill: "currentColor"
		})
	]
});
export default SvgLogoSm;
